import {observable, action, runInAction} from 'mobx'
import {json, get} from "../../../utils/ajax";
import {handleSearchAndPage, ValueObjToObj, setStore} from "../../../utils/Utils";
import moment from 'moment'
import {message} from "antd";

class ShoppingCartStore {
    @observable loading
    @observable pagination
    @observable searchFields
    @observable list
    @observable selectedRowKeysId
    @observable gradeVal //数量改变时的值
    @observable gradeValIndex

    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {
            spareNo: '',
            materialNo: '',
            time: ''
        }
        this.list = []
        this.selectedRowKeysId = []
        this.gradeVal = ''
        this.gradeValIndex = ''
    }

    /**
     * 将页面的值绑到store
     * @param changedFields
     */
    @action
    onFieldsChange = (changedFields) => {
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 页面初始化
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        let search = handleSearchAndPage(page, this.pagination, this.searchFields);
        search[`search.beginTime`] = this.searchFields.time.length > 0 ? moment(this.searchFields.time[0]).format("YYYY-MM-DD") : '';
        search[`search.endTime`] = this.searchFields.time.length > 0 ? moment(this.searchFields.time[1]).format("YYYY-MM-DD") : '';
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/getListForPage`, search);
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.gradeValIndex = ''
            this.loading = false
        })
    }

    /**
     * 重置表单
     */
    @action
    clearSearch = async () => {
        this.searchFields = {
            spareNo: '',
            materialNo: '',
            time: ''
        }
        await this.initPage()
    }

    /**
     * 选中行的id
     * @param selectedRowKeys
     */
    @action
    selectedRowKeys = (selectedRowKeys) => {
        this.selectedRowKeysId = selectedRowKeys
    }

    /**
     * 批量删除
     * @returns {Promise<void>}
     */
    @action
    editPlaceOrder = async () => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/batchDel`, this.selectedRowKeysId)
        await this.initPage()
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 删除
     */
    @action
    deleteData = async (id) => {
        let ids = [id]
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/batchDel`, ids)
        await this.initPage()
    }

    /***
     * 修改数量
     * @param value
     * @param record
     * @returns {Promise<void>}
     */
    @action
    onBlurGradeData = async (value, record) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/updateCount/${record.id}/${value}`)
        if (res.status) {
            message.success(`修改成功！`)
        } else {
            message.error(`修改失败！`)
        }
        await this.initPage(this.pagination.current)
    }
}

export default new ShoppingCartStore()



// WEBPACK FOOTER //
// ./src/project/dongfeng/ShoppingCart/store.js